module.exports = __webpack_public_path__ + "static/img/pro_03.e085a51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/agent/pro_03.png
// module id = 4Uqt
// module chunks = 6